import { Environment } from 'config/environment'
import { BankingValueObjectsOnboardingCreationSourceValueEnum } from 'generated/resources/graphql'

export const getAccountUrl = (
  environment: Environment,
  source: BankingValueObjectsOnboardingCreationSourceValueEnum,
  legalEntityId?: string
) => {
  const legalEntityIdParam = legalEntityId ? `&legal_entity_id=${legalEntityId}` : ''
  return `${environment.apiEndpoint}/expenses/account/account_link?source=${source}${legalEntityIdParam}`
}
